import { useCallback, useMemo } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import NavigationTabs, {
  NavigationTab,
} from '@antimatterhq/ui/components/navigationTabs';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { WarehouseLocationsDropdown } from '@/components/dropdown';
import { PageHeader } from '@/components/pageHeader/PageHeader';
import { PageBody } from '@/components/pageBody/PageBody';
import { useInitializationCheck } from '@/hooks/initialization/useInitializationCheck';

const TABS: NavigationTab[] = [
  {
    id: 'data-sources',
    label: 'Datasources',
  },
  {
    id: 'detection-rules',
    label: 'Detection rules',
  },
  {
    id: 'transforms',
    label: 'Transforms',
  },
  {
    id: 'workspace',
    label: 'Workspace',
  },
  {
    id: 'admin',
    label: 'Admin',
  },
];

export default function Configure() {
  const { initialized } = useInitializationCheck();

  const { enableTransforms } = useFlags<FlagSet>();
  const navigate = useNavigate();
  const match = useMatch('/configure/:childPath/*');
  const activeTab = match?.params?.childPath || '';

  const setActiveTab = useCallback(
    (tab: string) => {
      navigate(`/configure/${tab}`);
    },
    [navigate],
  );

  const tabs = useMemo(
    () => TABS.filter((tab) => enableTransforms || tab.id !== 'transforms'),
    [enableTransforms],
  );

  if (!initialized) {
    return null;
  }

  return (
    <>
      <PageHeader pageTitle="Configure">
        <div className="flex h-9 items-center border-b border-gray-300">
          <div className="flex-grow">
            <NavigationTabs
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={setActiveTab}
              className="border-none"
            />
          </div>
          <WarehouseLocationsDropdown className="mb-auto" />
        </div>
      </PageHeader>
      <PageBody>
        <Outlet />
      </PageBody>
    </>
  );
}
